export default "__VITE_ASSET__2985702f__"